module.exports = __webpack_public_path__ + "img/2.b6b70f93.jpg";